export const okrRegularFields = [
  {
    name: "name",
    label: "title",
  },
  {
    name: "ownerIds",
    label: "owner_cap",
  },
  {
    name: "parentId",
    label: "parent",
  },
  {
    name: "description",
    label: "description",
  },
];
